var _path;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgStimulationUltrasound = function SvgStimulationUltrasound(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    fillRule: "evenodd",
    d: "M14.62 5l-.569.543a2.954 2.954 0 0 1-2.051.81 2.951 2.951 0 0 1-2.051-.81L9.379 5 0 13.943l.57.542C3.621 17.396 7.681 19 12 19c4.317 0 8.377-1.604 11.43-4.515l.57-.542L14.62 5zM12 17.463c-3.618 0-7.034-1.25-9.705-3.535l3.94-3.758A9.196 9.196 0 0 0 12 12.166v-1.537a7.558 7.558 0 0 1-4.62-1.55l2.05-1.954c.748.498 1.637.765 2.57.765.932 0 1.82-.267 2.57-.765l4.91 4.681c-2.077 1.724-4.7 2.673-7.48 2.673v1.537c3.212 0 6.245-1.102 8.629-3.115l1.076 1.027c-2.672 2.285-6.088 3.535-9.705 3.535z"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgStimulationUltrasound, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/stimulation-ultrasound.a0a6f2ec.svg";
export { ForwardRef as ReactComponent };